import { placementSize } from '../config.js';
import { gameState } from '../state/gameState.js';
import { perspectiveBox, placementProfile } from './placementPerspective.mjs';

// Size a placed sprite to fit a base box while preserving the texture's natural aspect
// ratio — so tall lampposts / wide rugs aren't squished into a square. Decorations use
// their per-item base from the catalog (authored in the Size Lab); furniture/budy use
// placementSize. Returns the sprite for chaining.
// Mirror a placed sprite left/right when its placement carries flipped:true.
// Safe on every placement — non-flippable items simply never have the flag.
export function applyPlacementFlip(sprite, placement) {
  sprite.setFlipX(!!placement?.flipped);
  return sprite;
}

export function applyPlacementSize(sprite, item) {
  const base = gameState.raw?.catalog?.decorations?.[item]?.size ?? placementSize(item);
  const w = sprite.width || base;   // natural texture px (texture already set on the image)
  const h = sprite.height || base;
  const scale = base / Math.max(w, h);
  sprite.setDisplaySize(w * scale, h * scale);
  return sprite;
}

// The size and the room's perspective together (placementPerspective.mjs): full size, then smaller towards the back
// wall with the bottom edge kept. `profile`: the scene's perspective (null outdoors). The sprite keeps the scale it was
// drawn at as `perspectiveScale` (whoever sits on the piece is drawn at it too).
export function sizePlacement(sprite, placement, profile) {
  applyPlacementSize(sprite, placement.item);
  const b = perspectiveBox({ x: placement.x, y: placement.y, w: sprite.displayWidth, h: sprite.displayHeight },
    placementProfile(placement, profile));
  sprite.setDisplaySize(b.w, b.h).setPosition(b.x, b.y);
  sprite.perspectiveScale = b.scale;
  return sprite;
}
